<script lang="ts">
	import { bookDemo } from '$lib/state/global.svelte';
	import { buttonVariants } from '$lib/components/ui/button';
	import Image from '$lib/components/image.svelte';
	import type { ComponentSectionsHero } from '$lib/graphql/strapiApi';
	import { cn } from '$lib/utils.js';
	import { mode } from '$lib/state/global.svelte';

	let {
		content
	}: {
		content: ComponentSectionsHero & { heroTitle?: string | null; heroDescription?: string | null };
	} = $props();

	let imageSrc = $derived(
		$mode === 'light'
			? (content.picture?.formats?.xlarge?.url ?? content.picture?.url)
			: (content.darkPicture?.formats?.xlarge?.url ??
					content.darkPicture?.url ??
					content.picture?.formats?.xlarge?.url ??
					content.picture?.url)
	);
</script>

<div class="mt-5 flex flex-row justify-center gap-16 max-md:flex-col max-md:items-center">
	<div class="flex flex-col justify-center gap-6 text-center">
		<h1 class="text-4xl font-bold md:text-left">{content.heroTitle}</h1>
		<p class="max-w-lg text-lg md:text-left [&_a]:font-semibold">{@html content.richDescription?.body || content.description}</p>
		<div class="flex flex-row flex-wrap gap-4 max-md:justify-center">
			{#each content.buttons?.filter((x) => x !== null) ?? [] as button}
				{#if button.url?.startsWith('/') || button.url?.startsWith('http')}
					<a
						href={button.url}
						rel="noopener noreferrer"
						target={button.newTab ? '_blank' : undefined}
					>
						<div
							class={cn(
								buttonVariants({
									variant: button.type === 'primary' ? 'default' : 'outline'
									// variant: 'ghost'
								}),
								'text-base'
							)}
						>
							<!-- <Icon.Twitter class="size-3 fill-current" /> -->
							<span class="">{button.text}</span>
						</div>
					</a>
				{:else if button.url === 'demo'}
					<button onclick={bookDemo}>
						<div
							class={cn(
								buttonVariants({
									size: 'default',
									variant: 'outline'
								}),
								'text-base'
							)}
						>
							<!-- <Icon.GitHub class="size-4" /> -->
							<span class="">{button.text}</span>
						</div>
					</button>
				{/if}
			{/each}
		</div>
	</div>
	{#if imageSrc}
		<div class="md:max-w-[60%]">
			<Image
				class="rounded-xl drop-shadow-[0_0_8px_rgba(0,0,0,0.25)]"
				src={imageSrc}
				alt={content.picture.alternativeText}
			/>
		</div>
	{/if}
</div>
